import React from "react";
import {DisplayDictionary} from "../RecruiterParametersDictionaries";

export {RecruiterParametersDictionarySkills}

const RecruiterParametersDictionarySkills = (props: any) => {
  
  return(<div className={"container white-container"}>
    <h1 className={"profile-edit__title"}>Dictionnaire des compétences métier</h1>
  
    <DisplayDictionary keyValue={"skill"} data={props.dictionary || []} updateDictionaryEntry={()=>{}} deleteDictionaryEntry={()=>{}} />
  
  </div>);
}